import { Store, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createBrowserHistory } from 'history';
import { createRouterMiddleware } from './utils/customRouter';

import { ApplicationState, createRootReducer, rootSaga } from './store';

export const history = createBrowserHistory();

export default function configureStore(
  initialState?: ApplicationState
): Store<ApplicationState> {
  const composeEnhancers = composeWithDevTools({});
  const sagaMiddleware = createSagaMiddleware();

  const store = createStore(
    createRootReducer(history),
    initialState as object,
    composeEnhancers(
      applyMiddleware(
        createRouterMiddleware(history),
        sagaMiddleware
      )
    )
  );

  sagaMiddleware.run(rootSaga);
  return store;
}
